import CommunicationStatusBadge from "./CommunicationStatusBadge";

function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat("nl-NL", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

function getDeliveryStateLabel(value) {
  const labels = {
    not_sent: "Niet verzonden",
    pending: "In wachtrij",
    sent: "Verzonden",
    delivered: "Afgeleverd",
    opened: "Geopend",
    clicked: "Geklikt",
    auto_replied: "Auto-reply",
    unsubscribed: "Uitgeschreven",
    bounced: "Gebounced",
    failed: "Mislukt",
    suppressed: "Onderdrukt",
    policy_rejected: "Geweigerd",
    complaint: "Spamklacht",
  };
  return labels[String(value || "").trim()] || "Onbekend";
}

export default function CommunicationContextPanel({ thread }) {
  const rows = [
    { label: "Klant", value: thread?.clientId?.naam || "-" },
    {
      label: "Project",
      value:
        thread?.projectId?.naam ||
        thread?.projectId?.title ||
        thread?.projectId?.projectNummer ||
        thread?.projectId?.number ||
        "Niet gekoppeld",
    },
    { label: "Kanaal", value: thread?.channel || "manual" },
    { label: "Laatste bericht", value: formatDate(thread?.lastMessageAt) },
    { label: "Mailstatus", value: getDeliveryStateLabel(thread?.deliveryState) },
    { label: "Deelnemers", value: Array.isArray(thread?.participants) ? thread.participants.length : 0 },
  ];

  return (
    <section className="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs uppercase tracking-wide text-slate-500">Communicatiecontext</p>
          <div className="mt-1 flex flex-wrap items-center gap-2">
            <h3 className="text-lg font-semibold text-slate-900">{thread?.subject || "Gesprek"}</h3>
            {thread?.needsInternalAttention ? (
              <span className="inline-flex items-center rounded-full border border-rose-200 bg-rose-50 px-2.5 py-1 text-xs font-semibold text-rose-700">
                Nieuwe klantreactie
              </span>
            ) : null}
            {thread?.visibility?.customerPortalVisible ? (
              <span className="inline-flex items-center rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700">
                Zichtbaar in klantportaal
              </span>
            ) : null}
            {thread?.visibility?.customerPortalVisible ? (
              <span
                className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${
                  thread?.portalAllowReply !== false
                    ? "border-blue-200 bg-blue-50 text-blue-700"
                    : "border-slate-200 bg-slate-100 text-slate-700"
                }`}
              >
                {thread?.portalAllowReply !== false ? "Klant kan reageren" : "Reacties geblokkeerd"}
              </span>
            ) : null}
          </div>
        </div>
        <CommunicationStatusBadge status={thread?.status} />
      </div>

      <dl className="mt-4 grid gap-3 md:grid-cols-2">
        {rows.map((row) => (
          <div key={row.label}>
            <dt className="text-xs uppercase tracking-wide text-slate-500">{row.label}</dt>
            <dd className="mt-1 text-sm text-slate-800">{row.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
